import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import VuetablePagination from "./tables/table-pagination";

/**
 *  Element UI Components
 */
import { Autocomplete, ColorPicker, DatePicker, Popconfirm, Popover, Select, Slider, Switch, TimePicker, Upload } from "element-ui";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

/**
 * Wysiwyg rich text editor component: Quill
 */
import VueQuillEditor, { Quill } from "vue-quill-editor";
import "quill/dist/quill.snow.css";

/**
 * Draggable Component
 */
import draggable from "vuedraggable";

/**
 * Recycle scroller component
 */
import VirtualScrollList from "vue-virtual-scroll-list";

/**
 * Drag and Drop Media
 */
import vue2Dropzone from "vue2-dropzone";
import VueApexCharts from "vue-apexcharts";
import { MountingPortal, Portal, PortalTarget } from "portal-vue";

Vue.component("vue-dropzone", vue2Dropzone);
Vue.component("portal", Portal);
Vue.component("portal-target", PortalTarget);
Vue.component("mounting-portal", MountingPortal);
/**
 *  vue-table-component
 */
Vue.component("vuetable", Vuetable);
Vue.component("vuetable-pagination", VuetablePagination);
Vue.component("vuetable-pagination-info", VuetablePaginationInfo);

// configure language
locale.use(lang);
Vue.component(DatePicker.name, DatePicker, {locale});
Vue.component(TimePicker.name, TimePicker);
Vue.component(Select.name, Select);
Vue.component(Switch.name, Switch);
Vue.component(Upload.name, Upload);
Vue.component(Autocomplete.name, Autocomplete);
Vue.component(ColorPicker.name, ColorPicker);
Vue.component(Slider.name, Slider);
Vue.component(Autocomplete.name, Autocomplete);
Vue.component(Popover.name, Popover);
Vue.component(Popconfirm.name, Popconfirm);

Vue.component("apexchart", VueApexCharts);

const icons = Quill.import("ui/icons");
icons["bold"] = "<i class=\"mdi mdi-format-bold \"</i>";
icons["italic"] = "<i class=\"mdi mdi-format-italic\"</i>";
icons["underline"] = "<i class=\"mdi mdi-format-underline\"</i>";
icons["strike"] = "<i class=\"mdi mdi-format-strikethrough\"</i>";
icons["blockquote"] = "<i class=\"mdi mdi-format-quote-close\"</i>";
icons["header"]["1"] = "<i class=\"mdi mdi-format-header-1\"</i>";
icons["header"]["2"] = "<i class=\"mdi mdi-format-header-2\"</i>";
icons["list"]["ordered"] = "<i class=\"mdi mdi-format-list-numbers\"</i>";
icons["list"]["bullet"] = "<i class=\"mdi mdi-format-list-bulleted\"</i>";
icons["color"] = "<i class=\"mdi mdi-format-color-text\"</i>";
icons["background"] = "<i class=\"mdi mdi-format-color-fill\"</i>";
icons["clean"] = "<i class=\"mdi mdi-format-clear\"</i>";
icons["link"] = "<i class=\"mdi mdi-link\"</i>";
icons["image"] = "<i class=\"mdi mdi-image\"</i>";
icons["code"] = "<i class=\"mdi mdi-code-tags\"</i>";

Vue.use(VueQuillEditor, {theme: "snow"});

Vue.component("image-viewer-modal", require("./images/ImageViewerModal.vue").default);
Vue.component("lightbox", require("./images/lightbox").default);
Vue.component("video-box", require("./videos/VideoBox").default);

Vue.component("photo-list", require("./images/photo-list").default);

Vue.component(draggable.name, draggable);

Vue.component("virtual-list", VirtualScrollList);

Vue.component("image-upload", require("./settings/team/image-upload").default);

Vue.component("audit-log", require("./audit/audit-log").default);

Vue.component("password-input", require("./login/password-input").default);

/**
 * Layout Components
 */
Vue.component("top-nav", require("./navbar/TopNav").default);
Vue.component("top-nav-button", require("./navbar/TopNavButton").default);
Vue.component("top-nav-button-mobile", require("./navbar/TopNavButtonMobile").default);

/**
 * Registration & Auth Pages
 */
Vue.component("registration-page", require("./auth/RegistrationPage").default);

/**
 * Profile
 */
require("./users/show-user");
require("./users/user-profile");
require("./users/user-permissions");
require("./users/user-notifications");

/**
 * System Communication / Notifications
 */
Vue.component("system-notification-list", require("./system_notification/SystemNotificationList").default);
Vue.component("system-notification-modal", require("./system_notification/SystemNotificationModal").default);
Vue.component("system-notification-list-item", require("./system_notification/SystemNotificationListItem").default);

/**
 * Nav bar help
 */
Vue.component("help-list", require("./navbar/HelpList").default);

/**
 * Notes
 */
Vue.component("notes-panel", require("./notes/notes-panel").default);

/**
 * Settings
 */
require("./settings/settings");
require("./settings/team/team-detail-form");
require("./settings/billing/subscribe");
Vue.component("users", require("./users/UserList").default);
Vue.component("create-user-form", require("../components/settings/users/CreateUserForm").default);
require("./settings/portfolios/portfolios");
require("./settings/portfolios/portfolio");
require("./settings/mailboxes/mailboxes");
require("./settings/mailboxes/create-mailbox");
require("./settings/mailboxes/edit-mailbox");
require("./settings/mailboxes/auto-responder");
Vue.component("webhook-settings", require("./settings/webhooks/WebhookSettings").default);
require("./settings/inspections/inspection-settings");
require("./settings/tickets/ticket-settings");
require("./settings/tickets/ticket-phases");
require("./settings/tickets/tickets-mass-resolve-modal");
require("./settings/quotes-invoices/quotes-invoices-settings");
require("./settings/tickets/system-saved-replies");
require("./settings/inspections/checklist-sets");
require("./settings/inspections/inspection-templates");
Vue.component("subscription-account", require("../components/settings/subscription-account/subscription-account").default);
Vue.component("create-subscription-transaction", require("../components/settings/subscription-account/create-subscription-transaction").default);

/**
 * Registration and Onboarding
 */
require("./registration/registration-tasks");
Vue.component("debit-order-pending", require("./registration/tasks/debit-order-pending").default);
Vue.component("payment-pending", require("./registration/tasks/payment-pending").default);
Vue.component("debitorder", require("./registration/debitorder").default);

/**
 * Saved Replies
 */
Vue.component("saved-replies-list", require("../components/saved-replies/SavedRepliesList").default);
Vue.component("saved-reply", require("../components/saved-replies/SavedReply").default);
Vue.component("saved-reply-notification-input", require("../components/saved-replies/SavedReplyNotificationInput.vue").default);

/*
 * Communication Scenarios
 */
Vue.component("communication-scenarios-list", require("./communication-scenarios/CommunicationScenariosList").default);
Vue.component("communication-scenario-update-create-modal", require("./communication-scenarios/CommunicationScenarioCreateUpdateModal").default);

/**
 * Main dashboard
 */
Vue.component("home-dashboard", require("./home-dashboard/HomeDashboard").default);
Vue.component("welcome-modal", require("./WelcomeModal").default);

/**
 * Reporting Dashboard
 */
Vue.component("reporting-dashboard", require("./reporting-dashboard/ReportingDashboard").default);
Vue.component("ticket-risk-cases", require("./reporting-dashboard/ticket-risk-cases").default);
Vue.component("asset-stats", require("./reporting-dashboard/PropertyStats").default);

/**
 * Addresses
 */
Vue.component("address-update-form", require("./address/address-update-form").default);

/**
 * Assets
 */
require("./assets/view-asset");
require("./assets/asset-update-form");
Vue.component("create-asset", require("./assets/CreateAsset").default);
Vue.component("merge-property-modal", require("./assets/merge-property-modal").default);
Vue.component("merge-contacts-modal", require("./contacts/merge-contacts-modal").default);
Vue.component("assets-list", require("./assets/AssetsList").default);
Vue.component("assets-list-new", require("./assets/AssetListNew.vue").default);
Vue.component("assets-drop-down-item", require("./assets/AssetDropDownItem.vue").default);
Vue.component("view-asset-new", require("./assets/ViewAsset.vue").default);

/**
 * Asset Groups
 */
require("./assets/groups/asset-groups");
require("./assets/groups/create-asset-group");
require("./assets/groups/view-asset-group");
require("./assets/groups/asset-group-form");
Vue.component("asset-group-assets", require("./assets/groups/asset-group-assets").default);

/**
 * Contacts
 */
require("./contacts/contacts");
require("./contacts/create-contact");

/**
 * Contactables
 */
require("./contactable/contacts-list-all-roles");
Vue.component("ContactsListSingleRole", require("./contactable/ContactsListSingleRole").default);
Vue.component("contact-link-list", require("./contactable/ContactLinkList").default);
Vue.component("create-link-contact", require("./contacts/create-link-contact").default);
Vue.component("create-contact-for-link-list", require("./contacts/CreateContactForLinkList").default);
Vue.component("contact-view-edit", require("./contacts/contact-view-edit").default);
Vue.component("contact-groups", require("./contacts/ContactGroups").default);
Vue.component("change-contact-group", require("./contact-groups/ChangeContactGroup").default);

/*
 * SMS Messages
 */
Vue.component("create-new-sms", require("./sms/create-new-sms").default);
Vue.component("sms-messages", require("./sms/sms-messages").default);
Vue.component("view-sms", require("./sms/view-sms").default);

/*
* Quotes Invoices
 */
require("./quotes-invoices/quotes-invoices");
Vue.component("quote-invoice", require("./quotes-invoices/QuoteInvoice").default);
Vue.component("related-quotes-and-invoices", require("./quotes-invoices/RelatedQuotesAndInvoices").default);
Vue.component("quote-invoice-line-item", require("./quotes-invoices/QuoteInvoiceLineItem").default);

/**
 * Service Providers
 */
require("./serviceproviders/service-providers");
require("./serviceproviders/create-service-provider");
require("./serviceproviders/view-service-provider");
require("./serviceproviders/service-provider-update-form");
Vue.component("task-service-provider-modal-base", require("./tickets/task-service-provider-modal/TaskServiceProviderModalBase").default);
Vue.component("task-service-provider-modal-select-issues", require("./tickets/task-service-provider-modal/TaskServiceProviderModalSelectIssues").default);
Vue.component("task-service-provider-modal-select-task-settings", require("./tickets/task-service-provider-modal/TaskServiceProviderModalSelectTaskSettings").default);
Vue.component("task-service-provider-modal-communication", require("./tickets/task-service-provider-modal/TaskServiceProviderModalCommunication").default);
Vue.component("task-service-provider-modal-summary", require("./tickets/task-service-provider-modal/TaskServiceProviderModalSummary").default);

/**
 * Tickets
 */
Vue.component("tickets-list", require("./tickets/TicketsList").default);
Vue.component("model-has-tickets-list", require("./tickets/ModalHasTicketsList").default);
require("./tickets/view-ticket");
require("./tickets/issue-list");
Vue.component("ticket-main-details-form", require("./tickets/TicketMainDetailsForm").default);
Vue.component("ticket-asset-select-form", require("./tickets/ticket-asset-select-form").default);
Vue.component("select-ticket", require("./tickets/select-ticket").default);
Vue.component("close-ticket", require("./tickets/CloseTicketForm").default);
Vue.component("user-activity", require("./tickets/activities/user-activity").default);
Vue.component("ticket-activity", require("./tickets/activities/ticket-activity").default);
Vue.component("email-activity", require("./tickets/activities/email-activity").default);
Vue.component("document-activity", require("./tickets/activities/document-activity").default);
Vue.component("sms-activity", require("./tickets/activities/sms-activity").default);
Vue.component("service-provider-activity", require("./tickets/activities/service-provider-activity").default);
Vue.component("activity-edit-create-form", require("./tickets/activities/ActivityEditCreateForm").default);
Vue.component("ticket-activities-list", require("./tickets/activities/TicketActivitiesList").default);
Vue.component("task-card", require("./service-provider-teams/TaskCard").default);
Vue.component("task-card-contact-details", require("./service-provider-teams/TaskCardContactDetails").default);
Vue.component("maintenance-request-activity", require("./tickets/activities/maintenance-request-activity").default);
Vue.component("ticket-issue-form", require("./tickets/issues/TicketIssueForm").default);
Vue.component("ticket-service-provider-list", require("./tickets/TicketServiceProvidersList").default);
Vue.component("ticket-create-modal-base", require("./tickets/ticket-create-modal/TicketCreateModalBase").default);
Vue.component("ticket-create-modal-create-issues", require("./tickets/ticket-create-modal/TicketCreateModalCreateIssues").default);
Vue.component("ticket-create-modal-select-details", require("./tickets/ticket-create-modal/TicketCreateModalSelectDetails").default);
Vue.component("ticket-create-modal-summary", require("./tickets/ticket-create-modal/TicketCreateModalSummary").default);
Vue.component("ticket-auto-description", require("./tickets/ticket-create-modal/TicketAutoDescription").default);

/**
 * Issues
 */
Vue.component("bulk-update-issues-dropdown", require("./tickets/issues/BulkUpdateIssuesDropdown").default);

/**
 * Inspections
 */
require("./inspections/view-inspection");
require("./inspections/inspection-update-form");
require("./inspections/inspection-area-create-form");
require("./inspections/inspection-area-update-form");
require("./inspections/checklist-item-create-form");
require("./inspections/checklist-item-edit-form");
require("./inspections/checklist-item-row");
require("./inspections/checklist-items-sorting");
require("./inspections/inspection-asset-select-form");

Vue.component("inspection-list", require("./inspections/InspectionList").default);
Vue.component("inspection-checklist-areas-sorting-modal", require("./inspections/InspectionChecklistAreasSorting").default);
Vue.component("inspection-create-form", require("./inspections/InspectionCreateForm").default);
Vue.component("inspection-ticket-linking-modal", require("./inspections/InspectionTicketLinkingModal").default);
Vue.component("select-inspection", require("./inspections/select-inspection").default);
Vue.component("inspection-comparison", require("./inspections/comparisons/inspection-comparison").default);
Vue.component("comparison-item-detail", require("./inspections/comparisons/comparison-item-detail").default);
Vue.component("inspection-online-report-badge", require("./inspections/InspectionOnlineReportBadge.vue").default);
Vue.component("inspection-endpoint-usage-stats", require("./inspections/InspectionEndpointUsageStats.vue").default);

/**
 * Reminders
 */
Vue.component("reminders-list", require("./reminders/RemindersList").default);

/**
 * Messaging
 */
Vue.component("email-threads-panel", require("./inbox/email-threads-panel").default);
Vue.component("create-email", require("./inbox/create-email").default);
Vue.component("mailbox-required", require("./inbox/mailbox-required").default);
Vue.component("sent-mail", require("./inbox/sent-mail").default);
Vue.component("received-mail", require("./inbox/received-mail").default);
Vue.component("email-input", require("./inbox/email-input").default);
Vue.component("link-thread-ticket", require("./inbox/link-thread-ticket").default);
Vue.component("link-thread-inspection", require("./inbox/link-thread-inspection").default);
Vue.component("email-events", require("./inbox/email-events").default);
Vue.component("view-thread", require("./inbox/ViewThread").default);
Vue.component("inbox-dashboard", require("./inbox/InboxDashboard").default);
Vue.component("inbox-list", require("./inbox/InboxList").default);

/**
 * Documents
 */
Vue.component("document-list", require("./documents/document-list").default);

/*Sinov8 Library Components*/
Vue.component("badge", require("./library/Badge").default);
Vue.component("checkbox", require("./library/Checkbox").default);
Vue.component("color-picker", require("./library/ColorPicker").default);
Vue.component("confirmation-dialog", require("./library/ConfirmationDialog").default);
Vue.component("expandable-filters-container", require("./library/ExpandableFiltersContainer").default);
Vue.component("loading-indicator", require("./library/LoadingIndicator").default);
Vue.component("password-field", require("./library/PasswordField").default);
Vue.component("remote-select", require("./library/RemoteSelect").default);
Vue.component("secondary-button", require("./library/SecondaryButton").default);
Vue.component("simple-pagination", require("./library/SimplePagination").default);
Vue.component("simple-dropdown", require("./library/SimpleDropdown").default);
Vue.component("multi-select-dropdown", require("./library/MultiSelect").default);
Vue.component("simple-dropdown-option", require("./library/SimpleDropdownOption").default);
Vue.component("simple-dropdown-with-multi-select", require("./library/SimpleDropdownWithMultiSelect").default);
Vue.component("simple-modal", require("./library/SimpleModal").default);
Vue.component("simple-pagination", require("./library/SimplePagination").default);
Vue.component("simple-radio-group-blocks", require("./library/SimpleRadioGroupBlocks").default);
Vue.component("simple-steps", require("./library/SimpleSteps").default);
Vue.component("simple-text-search-input", require("./library/SimpleTextSearchInput").default);
Vue.component("text-area", require("./library/TextArea").default);
Vue.component("text-input", require("./library/TextInput").default);
Vue.component("toggle", require("./library/Toggle").default);
Vue.component("tabs", require("./library/Tabs.vue").default);

/**
 * SVGs sorted alphabetically
 */
Vue.component("svg-initializing-team", require("./library/svgs/SVGInitializingTeam.vue").default);

/**
 * Icons sorted alphabetically
 */
Vue.component("icon-adjustments", require("./library/icons/Adjustments").default);
Vue.component("icon-archive-box", require("./library/icons/ArchiveBox").default);
Vue.component("icon-annotation", require("./library/icons/Annotation").default);
Vue.component("icon-at-symbol", require("./library/icons/AtSymbol").default);
Vue.component("icon-arrow-back", require("./library/icons/ArrowBack").default);
Vue.component("icon-arrow-down", require("./library/icons/ArrowDown").default);
Vue.component("icon-arrow-to-top-right", require("./library/icons/ArrowToTopRight.vue").default);
Vue.component("icon-badge", require("./library/icons/Badge").default);
Vue.component("icon-bookmark", require("./library/icons/Bookmark").default);
Vue.component("icon-briefcase", require("./library/icons/Briefcase").default);
Vue.component("icon-briefcase-plus", require("./library/icons/BriefcasePlus").default);
Vue.component("icon-calculator", require("./library/icons/Calculator").default);
Vue.component("icon-camera-plus", require("./library/icons/CameraPlus").default);
Vue.component("icon-cash", require("./library/icons/Cash").default);
Vue.component("icon-calendar", require("./library/icons/Calendar").default);
Vue.component("icon-clipboard-list", require("./library/icons/ClipboardList").default);
Vue.component("icon-chat", require("./library/icons/Chat").default);
Vue.component("icon-chat-alt", require("./library/icons/ChatAlt").default);
Vue.component("icon-check", require("./library/icons/Check").default);
Vue.component("icon-check-circle", require("./library/icons/CheckCircle").default);
Vue.component("icon-chevron-down", require("./library/icons/ChevronDown").default);
Vue.component("icon-chevron-down-double", require("./library/icons/ChevronDownDouble").default);
Vue.component("icon-chevron-right", require("./library/icons/ChevronRight").default);
Vue.component("icon-chevron-up", require("./library/icons/ChevronUp").default);
Vue.component("icon-chevron-up-double", require("./library/icons/ChevronUpDouble").default);
Vue.component("icon-chip", require("./library/icons/Chip").default);
Vue.component("icon-circle-loading", require("./library/icons/CircleLoading").default);
Vue.component("icon-clipboard-list", require("./library/icons/ClipboardList").default);
Vue.component("icon-clipboard-document-list", require("./library/icons/ClipboardDocumentList").default);
Vue.component("icon-cog", require("./library/icons/Cog").default);
Vue.component("icon-collection", require("./library/icons/Collection").default);
Vue.component("icon-credit-card", require("./library/icons/CreditCard").default);
Vue.component("icon-device-mobile", require("./library/icons/DeviceMobile").default);
Vue.component("icon-document-text", require("./library/icons/DocumentText").default);
Vue.component("icon-document-download", require("./library/icons/DocumentDownload").default);
Vue.component("icon-document-outline", require("./library/icons/DocumentOutline").default);
Vue.component("icon-download", require("./library/icons/Download").default);
Vue.component("icon-email", require("./library/icons/Email").default);
Vue.component("icon-ellipsis-vertical", require("./library/icons/EllipsisVertical.vue").default);
Vue.component("icon-eye-on", require("./library/icons/EyeOn").default);
Vue.component("icon-eye-off", require("./library/icons/EyeOff").default);
Vue.component("icon-exclamation-circle", require("./library/icons/ExclamationCircle").default);
Vue.component("icon-external-link", require("./library/icons/ExternalLink").default);
Vue.component("icon-filter", require("./library/icons/FilterIcon").default);
Vue.component("icon-flag", require("./library/icons/Flag").default);
Vue.component("icon-folder-open", require("./library/icons/FolderOpen").default);
Vue.component("icon-folder-plus", require("./library/icons/FolderPlus").default);
Vue.component("icon-hammer-and-wrench", require("./library/icons/HammerAndWrench").default);
Vue.component("icon-help", require("./library/icons/Help").default);
Vue.component("icon-home", require("./library/icons/Home").default);
Vue.component("icon-inbox-in", require("./library/icons/InboxIn").default);
Vue.component("icon-information-circle", require("./library/icons/InformationCircle").default);
Vue.component("icon-library", require("./library/icons/Library").default);
Vue.component("icon-link", require("./library/icons/Link").default);
Vue.component("icon-location", require("./library/icons/Location").default);
Vue.component("icon-mail", require("./library/icons/Mail").default);
Vue.component("icon-message-failed", require("./library/icons/MessageFailed").default);
Vue.component("icon-paper-plane", require("./library/icons/Paperplane").default);
Vue.component("icon-pencil-alt", require("./library/icons/PencilAlt").default);
Vue.component("icon-pencil-box-multiple-filled", require("./library/icons/PencilBoxMultipleFilled").default);
Vue.component("icon-phone", require("./library/icons/Phone").default);
Vue.component("icon-photograph", require("./library/icons/Photograph").default);
Vue.component("icon-plus-circle", require("./library/icons/PlusCircle").default);
Vue.component("icon-presentation-chart-line", require("./library/icons/PresentationChartLine").default);
Vue.component("icon-refresh", require("./library/icons/Refresh").default);
Vue.component("icon-restore", require("./library/icons/Restore.vue").default);
Vue.component("icon-registered-service-provider", require("./library/icons/RegisteredServiceProvider").default);
Vue.component("icon-shield-check", require("./library/icons/ShieldCheck").default);
Vue.component("icon-tag", require("./library/icons/Tag").default);
Vue.component("icon-thumbs-up", require("./library/icons/ThumbsUp").default);
Vue.component("icon-ticket-outline", require("./library/icons/TicketOutline").default);
Vue.component("icon-time", require("./library/icons/Time").default);
Vue.component("icon-trash", require("./library/icons/Trash").default);
Vue.component("icon-user-add", require("./library/icons/UserAdd").default);
Vue.component("icon-user-circle-solid", require("./library/icons/UserCircleSolid").default);
Vue.component("icon-user-plus", require("./library/icons/UserPlus").default);
Vue.component("icon-user", require("./library/icons/User").default);
Vue.component("icon-users", require("./library/icons/Users").default);
Vue.component("icon-vertical-dots", require("./library/icons/VerticalMenuDots").default);
Vue.component("icon-wrench", require("./library/icons/Wrench").default);
Vue.component("icon-x-circle", require("./library/icons/XCircle").default);

// MultiUploadComponent Default Media Icons
Vue.component("icon-audio-solid", require("./library/icons/AudioSolid").default);
Vue.component("icon-document-solid", require("./library/icons/DocumentSolid").default);
Vue.component("icon-video-solid", require("./library/icons/VideoSolid").default);
Vue.component("icon-copy", require("./library/icons/Copy").default);

/**
 * Maintenance Requests
 */
Vue.component("maintenance-requests-dashboard", require("./maintenance-requests/MaintenanceRequestsDashboard").default);
Vue.component("maintenance-requests-list", require("./maintenance-requests/MaintenanceRequestsList").default);
Vue.component("maintenance-request-sharing-list", require("./maintenance-requests/MaintenanceRequestSharingList").default);
Vue.component("maintenance-request-settings-form", require("./maintenance-requests/MaintenanceRequestSettingsForm").default);
Vue.component("maintenance-request-settings-common-issues-list", require("./maintenance-requests/MaintenanceRequestSettingsCommonIssuesList").default);
Vue.component("share-maintenance-request-link-modal", require("./maintenance-requests/ShareMaintenanceRequestLinkModal").default);
Vue.component("reject-maintenance-request-issues-modal", require("./maintenance-requests/RejectMaintenanceRequestIssuesModal.vue").default);

/**
 * Todos
 */
Vue.component("todo-list", require("./todos/TodoList").default);
Vue.component("todo-list-item", require("./todos/TodoListItem").default);
Vue.component("todo-create-edit-form", require("./todos/TodoCreateEditForm").default);

/**
 * Transaction Requests
 */
Vue.component("transaction-request-create-update-form", require("./transaction-requests/TransactionRequestCreateUpdateForm").default);
Vue.component("transaction-request-list", require("./transaction-requests/TransactionRequestList").default);

/**
 * Integrations
 */
Vue.component("payprop-files-upload", require("./integrations/payprop-files-upload").default);
Vue.component("model-replication-tooltip", require("./integrations/ModelReplicationTooltip.vue").default);

/**
 * Custom inputs
 */
Vue.component("user-input-field", require("./users/UserInputField").default);

/**
 * Utilities
 */
Vue.component("archive-and-unarchive-modal", require("./utilities/ArchiveAndUnarchiveModal").default);
Vue.component("date-picker-modal", require("./utilities/date-picker-modal").default);
Vue.component("multi-upload-component", require("./utilities/MultiUploadComponent").default);
Vue.component("sortable-column-header", require("./utilities/SortableColumnHeader.vue").default);
/**
 * Messaging Portal
 */
Vue.component("inbox-channel-list", require("./messaging-portal/InboxMessengerChannelList").default);
Vue.component("ticket-channel-list", require("./messaging-portal/TicketMessengerChannelList").default);
Vue.component("messenger-channel-list-item", require("./messaging-portal/MessengerChannelListItem").default);
Vue.component("messenger-channel", require("./messaging-portal/MessengerChannel").default);
Vue.component("channel-container-modal", require("./messaging-portal/ChannelContainerModal").default);
Vue.component("media-message", require("./messaging-portal/MediaMessage").default);
Vue.component("media-message-preview", require("./messaging-portal/MediaMessagePreview").default);
Vue.component("text-message", require("./messaging-portal/TextMessage").default);
Vue.component("system-message", require("./messaging-portal/SystemMessage").default);
Vue.component("message-input", require("./messaging-portal/MessageInput").default);
Vue.component("media-message-preview", require("./messaging-portal/MediaMessagePreview").default);

/**
 * Activity Log
 */
Vue.component("activity-log", require("./activity-log/ActivityLog").default);
